import { GenerateElementProps, IContent } from "./IContent";
import { PERMISSIONS } from "../../../auth/permissions";

export abstract class ContentBase implements IContent {
  protected constructor(
    protected styles: string,
    protected permissions: PERMISSIONS[],
    protected condition = () => true,
    protected testAttribute?: string,
  ) {}

  withStyle(style: string): IContent {
    const c = this.clone() as ContentBase;
    c.styles = this.styles.concat(" ", style);
    return c;
  }

  withPermissions(permissions: PERMISSIONS[]): IContent {
    const c = this.clone() as ContentBase;
    c.permissions = permissions;
    return c;
  }

  withCondition(condition: () => boolean): IContent {
    const c = this.clone() as ContentBase;
    c.condition = condition;
    return c;
  }

  withTestAttribute(attributeName: string): IContent {
    const c = this.clone() as ContentBase;
    c.testAttribute = attributeName;
    return c;
  }

  generateElement(props: GenerateElementProps): JSX.Element | null {
    return props.hasPermissions(this.permissions) && this.condition()
      ? this.generateContentElement(props)
      : null;
  }

  protected abstract generateContentElement(
    props: GenerateElementProps,
  ): JSX.Element | null;
  abstract clone(): IContent;
}
